module.exports = __webpack_public_path__ + "encs/web_store/avpv/img/myTeams.169052a4.svg";